import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/List/List.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/ListItem/ListItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/awards-scroll/awards-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/common-interlinking/common-interlinking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/feefo-reviews-section/feefo-reviews-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/page-hero/base-page-hero/base-page-hero.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/text-module/text-module.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/why-collette/awards-reviews/explore-collette/explore-collette-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/why-collette/awards-reviews/review-carousel-section/review-carousel.tsx");
